/**
 * CourtsSection - Court naming for Americano (names stored in config.courtNames)
 */
import React, { useState, useEffect } from 'react';
import { useTournament } from '../../contexts/TournamentContext';

const CourtsSection = () => {
  const { state, setConfig } = useTournament();
  const { config } = state;

  const [courtNames, setCourtNames] = useState([]);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!config || initialized) return;

    const count = config.courtCount || 2;
    const existing = config.courtNames || [];
    const names = Array.from({ length: count }, (_, i) => existing[i] || `Terrain ${i + 1}`);
    setCourtNames(names);
    setInitialized(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config, initialized]);

  // Adjust when courtCount changes
  useEffect(() => {
    if (!initialized) return;
    const count = config?.courtCount || 2;
    setCourtNames(prev => {
      if (prev.length === count) return prev;
      if (prev.length < count) {
        return [...prev, ...Array.from({ length: count - prev.length }, (_, i) => `Terrain ${prev.length + i + 1}`)];
      }
      return prev.slice(0, count);
    });
  }, [config?.courtCount, initialized]);

  const handleChange = (index, value) => {
    setCourtNames(prev => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };

  const handleBlur = () => {
    setConfig({ courtNames: [...courtNames] });
  };

  const handleFocus = (e) => e.target.select();

  if (!config) return null;

  return (
    <div className="section-inner">
      <div className="section-header">
        <h1><i className="bi bi-grid-3x3-gap-fill me-3"></i>Terrains</h1>
        <p className="lead">{courtNames.length} terrain{courtNames.length > 1 ? 's' : ''}</p>
      </div>

      <div className="section-body">
        <div className="courts-list">
          {courtNames.map((name, index) => (
            <div key={index} className="court-row mb-3 p-3 border rounded">
              <div className="d-flex align-items-center gap-3">
                <span className="badge bg-success d-flex align-items-center gap-1" style={{ fontSize: '1rem', padding: '0.5rem 0.75rem' }}>
                  <i className="bi bi-grid-3x3-gap-fill"></i> {index + 1}
                </span>
                <div className="flex-grow-1">
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    maxLength={30}
                    autoComplete="off"
                    placeholder={`Terrain ${index + 1}`}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CourtsSection;
